import { CommonCatalogsNamesEnum } from '../enums/CommonCatalogsNamesEnum';

export const adminCommonCatalogsNames = [
  CommonCatalogsNamesEnum.KNM_ADDRESS_TYPES,
  CommonCatalogsNamesEnum.KNM_REASONS_CANCELED,
  CommonCatalogsNamesEnum.KNM_DELEGATE_TYPES,
  CommonCatalogsNamesEnum.KNM_EXECUTION_TYPES_ALL,
  CommonCatalogsNamesEnum.KNM_INSPECTOR_TYPES,
  CommonCatalogsNamesEnum.KNM_NOTICE_METHODS_ALL,
  CommonCatalogsNamesEnum.KNM_SUBJECT_TYPES_ALL,
  CommonCatalogsNamesEnum.KNM_TYPES_ALL,
  CommonCatalogsNamesEnum.KNM_KINDS_ALL,
  CommonCatalogsNamesEnum.KNM_VIOLATION_TYPES_ALL,
  CommonCatalogsNamesEnum.RISK_CATEGORIES,
  CommonCatalogsNamesEnum.TEST_PURCHASE_METHODS,
];
